import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

interface Headers {
  'Content-Type': string;
  Accept: string;
  token: string;
}

export type Response<Success> = AxiosPromise<Success>;

export interface StatusResponse {
  status: string;
}

const envHosts: { [key: string]: string } = {
  production: 'https://guest-api.guestservices.theknot.com',
  qa: 'https://qa-guest-api.guestservices.theknot.com',
  dev: 'http://qa-dev.theknot.com:5555/',
  staging: 'http://staging-web.guestservices.theknot.com/',
  staging2: 'http://staging2-web.guestservices.theknot.com/',
  qaWwsApi: 'https://qa.wws-api.authenticated.guestservices.theknot.com',
  productionWwsApi: 'https://prod.wws-api.authenticated.guestservices.theknot.com',
};

class Client {
  protected getWwsHost = (useWwsApi: boolean = false): string => {
    const env = process.env.GUEST_ENV || process.env.REACT_APP_GUEST_ENV || 'qa';
    const host = useWwsApi ? envHosts[`${env}WwsApi`] : envHosts[env];
    return host;
  };

  protected callWwsApi(path: string, config: AxiosRequestConfig = {}): AxiosPromise {
    return axios({
      url: path,
      ...config,
      headers: {
        ...this.baseHeaders(),
        ...config.headers,
      },
    });
  }

  private getSessionToken = (): string => {
    return Cookies.get('xo-session-token') || '';
  };

  private baseHeaders = (): Headers => {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: this.getSessionToken(),
    };
  };
}

export default Client;
